import React, { useState, useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";

const QRCodeGenerator = () => {
  const [cardId, setCardId] = useState("");
  const [profileUrl, setProfileUrl] = useState("");

  // Generate a random 16-character hex cardId (uppercase alphanumeric)
  const generateCardId = () => {
    const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let result = "";
    for (let i = 0; i < 16; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };

  // Generate profile URL based on current origin
  const generateProfileUrl = (id) => {
    const origin = window.location.origin;
    return `${origin}/profile/${id}`;
  };

  // Generate initial cardId on mount
  useEffect(() => {
    const newCardId = generateCardId();
    setCardId(newCardId);
    setProfileUrl(generateProfileUrl(newCardId));
  }, []);

  // Auto-generate new QR code every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      const newCardId = generateCardId();
      setCardId(newCardId);
      setProfileUrl(generateProfileUrl(newCardId));
    }, 5000); // 5 seconds

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);

  // Handle "Next" button - generate new QR code
  const handleNext = () => {
    const newCardId = generateCardId();
    setCardId(newCardId);
    setProfileUrl(generateProfileUrl(newCardId));
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-8">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-xl p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            QR Code Generator
          </h1>
          <p className="text-gray-600">
            Generate QR codes for NFC card profiles
          </p>
        </div>

        <div className="flex flex-col items-center space-y-6">
          {/* QR Code Display */}
          <div className="bg-white p-6 rounded-lg border-2 border-gray-200">
            <QRCodeSVG
              value={profileUrl}
              size={300}
              level="H"
              includeMargin={true}
            />
          </div>

          {/* Card ID Display */}
          <div className="text-center">
            <p className="text-sm text-gray-500 mb-2">Card ID:</p>
            <p className="text-xl font-mono font-bold text-gray-800 bg-gray-100 px-4 py-2 rounded">
              {cardId}
            </p>
          </div>

          {/* URL Display */}
          <div className="text-center w-full">
            <p className="text-sm text-gray-500 mb-2">Profile URL:</p>
            <p className="text-sm font-mono text-gray-700 bg-gray-50 px-4 py-2 rounded break-all">
              {profileUrl}
            </p>
          </div>

          {/* Next Button */}
          <button
            onClick={handleNext}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg text-lg transition-colors shadow-lg"
          >
            Generate Next QR Code
          </button>

          {/* Instructions */}
          <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-200">
            <p className="text-sm text-blue-800">
              <strong>Instructions:</strong> Scan this QR code and write it to
              your NFC card. Each QR code contains a unique profile link that
              users can tap to view.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRCodeGenerator;
